"use client";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { CategoryBarScroller } from "@/components/content/category-bar-scroller";
import { SortMenu } from "@/components/content/sort-menu";
import { cn } from "@/lib/utils";
import type { Daum } from "./actions";

const FORUM_SORT_OPTIONS = [
  { label: "En Yeni", value: "latest" },
  { label: "En Çok Yorumlanan", value: "most_replied" },
  { label: "En Çok Beğenilen", value: "most_liked" },
] as const;

const ForumCategoryBar = ({
  parentCategory,
  categories,
}: {
  parentCategory: string;
  categories: Daum[];
}) => {
  const activeCategory = useSearchParams().get("category") || "";
  return (
    <CategoryBarScroller>
      <SortMenu options={FORUM_SORT_OPTIONS} />
      <Link
        className={cn(
          "rounded-full border border-neutral-200 px-4 py-2 font-medium hover:bg-brand-blue-100 transition-colors",
          {
            "border-brand-blue-600 bg-brand-blue-600 text-white hover:bg-brand-blue-600":
              activeCategory === "",
          },
        )}
        href={`/forum/${parentCategory}`}
        prefetch={false}
      >
        Tümü
      </Link>
      {categories.map((category) => {
        return (
          <div
            className={cn("flex flex-row gap-1", {
              "bg-brand-blue-100 rounded-full w-fit":
                category.id === activeCategory,
            })}
            key={category.id}
          >
            <Link
              aria-disabled={category.id === activeCategory}
              className={cn(
                "rounded-full w-fit whitespace-nowrap shrink-0 border border-neutral-200 text-neutral-800 px-4 py-2 font-medium hover:bg-brand-blue-100 hover:border-brand-blue-500 transition-colors",
                {
                  "border-brand-blue-600 bg-brand-blue-600 text-white hover:bg-brand-blue-600":
                    category.id === activeCategory,
                },
              )}
              href={`/forum/${parentCategory}?category=${category.id}`}
              prefetch={false}
            >
              {category.name}
            </Link>
          </div>
        );
      })}
    </CategoryBarScroller>
  );
};

export default ForumCategoryBar;
